import type { IconData } from '@stacksjs/iconify-core'

export const ps1x1: IconData = {
  "body": "<path fill=\"#009639\" d=\"M0 0h512v512H0z\"/><path fill=\"#fff\" d=\"M0 0h512v341.3H0z\"/><path d=\"M0 0h512v170.7H0z\"/><path fill=\"#ed2e38\" d=\"m0 0l341.3 256L0 512Z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default ps1x1
